import data from './attrs/data'
import methods from './attrs/methods'
import mounted from './attrs/mounted'
import MaterialCard from '../../components/MaterialCard'
import MaterialAlert from '../../components/MaterialAlert'

export default {
  name: 'Login',
  data,
  methods,
  mounted,
  components: {
    MaterialCard,
    MaterialAlert,
  },
}
